export default __webpack_public_path__ + "static/media/banner_holygrail.ed495161.svg";